import React, { useState } from "react";
import { BiMenuAltRight } from "react-icons/bi";
import { CgClose } from "react-icons/cg";
import { Link } from "react-router-dom";
import { educareLogo } from "../../assets";
import { headerInfo } from "../../constants";
import FreeSeminarBtn from "../buttons/FreeSeminarBtn";
import TopHeader from "./TopHeader";

const Header = () => {
  const [showMenu, setShowMenu] = useState(false);
  return (
    <div className="w-full h-auto shadow-lg sticky top-0 z-50 bg-white">
      <TopHeader />
      <div className="max-w-screen-2xl flex justify-between relative py-4 px-4 mx-auto">
        <div className="flex justify-between w-full">
          <div>
            <Link to="/">
              <img className="w-64" src={educareLogo} alt="educareLogo" />
            </Link>
          </div>
          <div className="hidden lgl:flex items-center gap-4">
            <ul className="flex ml-6 flex-row justify-start items-center gap-4 font-titleFont text-[16px]">
              {headerInfo.map((headerItem) => (
                <li
                  key={headerItem.id}
                  className="relative text-center px-2 text-primeColor uppercase font-semibold group cursor-pointer hover:greenLight duration-300"
                >
                  <Link to={headerItem.link}>{headerItem.title}</Link>
                  <span className="absolute w-full transform scale-0 group-hover:scale-100 duration-500 h-[2px] -bottom-[1px] left-0 bg-primeColor inline-block"></span>
                </li>
              ))}
            </ul>
            <Link to="/freeseminar">
              <div>
                <FreeSeminarBtn />
              </div>
            </Link>
          </div>
        </div>
        <div className="inline-flex items-center justify-end lgl:hidden">
          {showMenu ? (
            <CgClose
              onClick={() => setShowMenu(!showMenu)}
              className="text-[40px] text-primeColor cursor-pointer hover:text-darkPink"
            />
          ) : (
            <BiMenuAltRight
              onClick={() => setShowMenu(!showMenu)}
              className="hover:fill-darkPink fill-primeColor cursor-pointer ease-in-out duration-300"
              size={45}
            />
          )}
          <div
            className={`absolute w-48 z-40 h-auto px-4 top-16 -right-2 bg-white  rounded-md ${
              showMenu ? "py-4" : "py-0"
            }`}
          >
            {showMenu ? (
              <div className="flex flex-col gap-[2px] relative">
                <ul className="flex ml-6 flex-col justify-start absolute w-36 py-4 rounded-lg bg-darkPink text-white top-[25px] items-center gap-4 font-titleFont text-[16px]">
                  {headerInfo.map((headerItem) => (
                    <li
                      onClick={() => setShowMenu(false)}
                      key={headerItem.id}
                      className="relative text-center px-2 uppercase font-semibold group cursor-pointer hover:greenLight duration-300"
                    >
                      <Link to={headerItem.link}>{headerItem.title}</Link>
                      <span className="absolute w-full transform scale-0 group-hover:scale-100 duration-500 h-[2px] -bottom-[1px] left-0 bg-primeColor inline-block"></span>
                    </li>
                  ))}
                </ul>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
